import { Box } from '@mui/material';
import { useCallback, useEffect, useRef } from 'react';
import Loader from '../../../components/Loader';

type Props = {
  receiptId: string;
  cashierToken: string;
};

const PrroReceipt = ({ receiptId, cashierToken }: Props) => {
  const timerRef = useRef<NodeJS.Timeout>();
  const ref = useRef<HTMLDivElement>(null);

  const getReceipt = useCallback(async () => {
    const res = await fetch(`https://api.checkbox.in.ua/api/v1/receipts/${receiptId}/html`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${cashierToken}`,
        'X-Client-Name': 'FireMenu',
        'X-Client-Version': 'v0.1.1',
      },
    });

    if (ref.current && res.status === 200) {
      const html = await res.text();
      clearInterval(timerRef.current);
      ref.current.innerHTML = html;
    }
  }, [cashierToken, receiptId]);

  useEffect(() => {
    getReceipt();
  }, [getReceipt]);

  return (
    <div ref={ref}>
      <Box p={18}>
        <Loader open />
      </Box>
    </div>
  );
};

export default PrroReceipt;
